import { Component, OnInit, ViewContainerRef } from "@angular/core";
import { Router } from "@angular/router";
import { overlayConfigFactory } from "angular2-modal";
import { BSModalContext, Modal } from "angular2-modal/plugins/bootstrap";
import { TranslateService } from "ng2-translate/ng2-translate";
import { geolocation } from "../../sharedcomponents/commonservice/geolocation/geoloc";
import { utilityService } from "../../sharedcomponents/commonservice/utility.service";
import {
  enumStatusCodeList,
  OrderData
} from "../../sharedcomponents/_common/constants/app.constants";
import { AlertPopupComponent } from "../../sharedcomponents/_directive/alert-popup/alert-popup.component";
import { RepeatorderService } from "../../_services/repeatorder/repeatorder.service";
import { SendMoneyService } from "../../_services/sendmoneyservice/sendmoneyservice";
import { PayagainFailedorderService } from "../../_services/transaction/payagain-failedorder.service";
import { TransactionHistoryService } from "../../_services/transaction/transaction-history.service";
import { AuthService } from 'app/_services/userservice/auth.service';

@Component({
  selector: "app-repeatorderdashboardlist",
  templateUrl: "./repeatorderlist-dashBoard.component.html",
  providers: [AuthService]
})
export class RepeatorderDashboardlistComponent implements OnInit {
  transcationlist: any = [];
  className = "";
  constructor(
    public utilserv: utilityService,
    private router: Router,
    public translate: TranslateService,
    public repeatOrder: RepeatorderService,
    public transHistory: TransactionHistoryService,
    public payeagainservice: PayagainFailedorderService,
    public modal: Modal,
    private sendMoneyService: SendMoneyService,
    private vcRef: ViewContainerRef,
    public geoloc: geolocation,
    private auth: AuthService
  ) {}
  ngOnInit() {
    this.utilserv.busy = this.translate
      .use(sessionStorage.langCode)
      .subscribe(data => {
        this.getrepeatorderlist();
      });
  }
  getrepeatorderlist() {
    const _self = this;
    this.utilserv.busy = this.repeatOrder
      .getRepeatorderDashBoardlistservice()
      .subscribe(
        data => {
          const response = data.Envelope.Body.OutGoingTransactionResponse;

          if (
            response.StatusCode == 20001 ||
            response.BeneficiaryTransactions.BeneficiaryTransaction == undefined
          ) {
            return false;
          }
          if (response.StatusCode == enumStatusCodeList.SUCCESS) {
            _self.transcationlist = _self.utilserv.getArray(
              response.BeneficiaryTransactions.BeneficiaryTransaction
            );
            _self.transcationlist = _self.sortByDate(_self.transcationlist);
          } else if (response.StatusCode == enumStatusCodeList.DataNotFound) {
            console.log(
              "No Data in DashBoard Repeat Order" + response.StatusCode
            );
          } else {
            console.log(
              "No Data in DashBoard Repeat Order" + response.StatusCode
            );
          }

          _self.auth.getUserDetail().subscribe(
            data => {
              const resJSON = data;
              if (resJSON.Envelope.Body.CustomerInfoResponse.StatusCode ==  enumStatusCodeList.SUCCESS) {
                _self.auth.setUserDetails(resJSON);
                sessionStorage.UserData = _self.utilserv.AESEncrypt(JSON.stringify(resJSON));
              }
            },
            error => {
              console.log("getting error" + error);
            }
          );
        },
        error => {}
      );
  }

  sortByDate(myArray): void {
    return myArray.sort((a, b) => {
      return (
        new Date(this.utilserv.getObjectText(b.RecentOrderDate)).getTime() -
        new Date(this.utilserv.getObjectText(a.RecentOrderDate)).getTime()
      );
    });
  }

  openusertranscation(transcationlist) {
    this.transHistory.settransactionhistoryData(transcationlist);

    this.router.navigate(["/transactionuserlist"]);
    return;
  }
  openQuickResend() {
    this.utilserv.busy = this.geoloc.islocPermissionable().subscribe(
      data => {
        const _self = this;
        if (data == undefined) {
          return;
        }
        if (data == true) {
          _self.router.navigate(["/repeatorderlist"]);
          return;
        } else {
          let modalData: any = {};
          modalData.Action = this.translate.instant("Common_lblOk");
          modalData.Title = this.translate.instant("Common_lblInfo").toString();
          modalData.Message = this.translate
            .instant("Common_lblLocationValidate")
            .toString();
          this.modal.overlay.defaultViewContainer = this.vcRef;
          return this.modal
            .open(
              AlertPopupComponent,
              overlayConfigFactory({ modalData }, BSModalContext)
            )
            .then(function(obj) {
              obj.onDestroy.subscribe(data => {
                _self.router.navigate(["/repeatorderlist"]);
                return;
              });
            });
        }
      },
      error => {}
    );
  }

  openrepeatorder(transcationlist) {
    if (
      this.utilserv.getObjectText(transcationlist.RecentOrderStatus) ==
        "PMT_CMPLTD" ||
      this.utilserv.getObjectText(transcationlist.RecentOrderStatus) ==
        "PMT_PAID"
    ) {
      this.utilserv.busy = this.geoloc.islocPermissionable().subscribe(
        data => {
          const _self = this;
          if (data == undefined) {
            return;
          }

          if (data == true) {
            const orderData: OrderData = new OrderData();
            orderData.OrderNo = this.utilserv.getObjectText(
              transcationlist.RecentOrderNumber
            );
            orderData.BenificiaryId = this.utilserv.getObjectText(
              transcationlist.Beneficiary.BeneficiaryId
            );
            sessionStorage.orderData = JSON.stringify(orderData);
            // _self.payeagainservice.setbeneficiaryforRepeatOrder(transcationlist);
            // _self.sendMoneyService.setRepeatOrderFlow('repeatorderlistdashboard');
            // _self.router.navigate(['/repeatorderlistdashboard']);
            _self.router.navigate(["/repeatorderlist"]);
            return;
          } else {
            let modalData: any = {};
            modalData.Action = this.translate.instant("Common_lblOk");
            modalData.Title = this.translate
              .instant("Common_lblInfo")
              .toString();
            modalData.Message = this.translate
              .instant("Common_lblLocationValidate")
              .toString();
            this.modal.overlay.defaultViewContainer = this.vcRef;
            return this.modal
              .open(
                AlertPopupComponent,
                overlayConfigFactory({ modalData }, BSModalContext)
              )
              .then(function(obj) {
                obj.onDestroy.subscribe(data => {
                  const orderData: OrderData = new OrderData();
                  orderData.OrderNo = _self.utilserv.getObjectText(
                    transcationlist.RecentOrderNumber
                  );
                  orderData.BenificiaryId = _self.utilserv.getObjectText(
                    transcationlist.Beneficiary.BeneficiaryId
                  );
                  sessionStorage.orderData = JSON.stringify(orderData);
                  // _self.payeagainservice.setbeneficiaryforRepeatOrder(transcationlist);
                  // _self.sendMoneyService.setRepeatOrderFlow('repeatorderlistdashboard');
                  // _self.router.navigate(['/repeatorderlistdashboard']);
                  _self.router.navigate(["/repeatorderlist"]);
                  return;
                });
              });
          }
        },
        error => {}
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/repeatorder/repeatorderlist-dashboard/repeatorderlist-dashBoard.component.ts